import { useQuery, UseQueryResult } from 'react-query';
import { UrlParams, RevenueCategoryAutoComplete } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams } from 'utils/functions';

interface IUseAutoCompleteCategoriesProps {
  search: string;
}

function useAutoCompleteRevenueCategories({
  search,
}: IUseAutoCompleteCategoriesProps): UseQueryResult<{ data: Array<RevenueCategoryAutoComplete> }> {
  const params: UrlParams = {};
  if (search) {
    params.search = search;
  }

  return useQuery(['revenue-categories-autocomplete', search], () =>
    client.get(`revenue-categories/auto-complete/?${encodeUrlParams(params)}`),
  );
}

export default useAutoCompleteRevenueCategories;
